/* eslint-disable @typescript-eslint/no-explicit-any */
import { Popover } from 'antd';
import dayjs from 'dayjs';
import { FC } from 'react';
import { DataStateItem, DataValue } from 'shared/types';
import { DateTimeField } from 'shared/ui/DateTimeField';
import { truncateString } from 'shared/utils';

interface ArrayTemplateProps {
  value: string
  dateFormat?: string
}

const ArrayTemplate: FC<ArrayTemplateProps> = ({ value, dateFormat }) => {
  if (!value) {
    return null;
  }
  const dots = value.split(';')?.length > 1 ? '...' : '';
  return (
    <Popover
      content={
        value.split(';').map((item) => (dateFormat ? <p>{dayjs(item).format(dateFormat)}</p> : <p>{item}</p>))
      }
    >
      <p>{dateFormat ? dayjs(value.split(';')[0]).format(dateFormat) + dots : value.split(';')[0] + dots}</p>
    </Popover>
  );
};

interface StringTemplateProps {
  value: string
}

const StringTemplate: FC<StringTemplateProps> = ({ value }) => {
  const shortedValue = truncateString(value, 30);
  return (
    <Popover
      content={
        shortedValue?.length > 30 ? value : null
      }
      overlayStyle={{ maxWidth: 500 }}

    >
      <p>{shortedValue}</p>
    </Popover>
  );
};

interface CalculateFieldProps {
  record: DataStateItem,
  value: DataValue,
  columnMeta: any,
}

export const CalculateField: FC<CalculateFieldProps> = ({ record, columnMeta, value }) => {
  const fieldType = record?.fieldDataType;
  switch (fieldType) {
  case 'STRING':
    return <StringTemplate value={value as string} />;
  case 'ARRAY_STRING':
    return <ArrayTemplate value={value as string} />;
  case 'ARRAY_DATE':
    return <ArrayTemplate value={value as string} dateFormat="DD.MM.YYYY" />;
  case 'DATE':
    return <DateTimeField value={value as string} sourceFormat={columnMeta.sourceFormat} targetFormat={columnMeta.targetFormat} />;
  default:
    return <StringTemplate value={value as string} />;
  }
};
